<template>
  <div style="background:#fff; border:1px solid #e9ecef; border-radius:12px; padding:16px 20px; display:flex; align-items:center; justify-content:space-between; gap:16px; cursor:pointer;">
    <div style="display:flex; align-items:center; gap:14px;">
      <span :style="tipoBadgeStyle">{{ tipoLabel }}</span>
      <div>
        <div style="font-size:14px; font-weight:600; color:#32325d;">
          <span v-if="auditoria.codigo" style="color:#8898aa; font-weight:400;">#{{ auditoria.codigo }} · </span>{{ fechaFormateada }}
        </div>
      </div>
    </div>

    <div style="display:flex; align-items:center; gap:12px;">
      <span style="font-size:18px; font-weight:600; color:#32325d;">{{ auditoria.score }}%</span>
      <span :style="escalaBadgeStyle">{{ auditoria.escala }}</span>
    </div>
  </div>
</template>

<script>
import { estiloEscala } from '../escalas'

export default {
  name: 'AuditoriaListItem',
  props: {
    auditoria: { type: Object, required: true }
  },
  computed: {
    tipoLabel () {
      return this.auditoria.tipo === 'franquicias' ? 'Franquicia' : 'Daily'
    },
    tipoBadgeStyle () {
      return {
        fontSize: '10px',
        fontWeight: '600',
        padding: '3px 10px',
        borderRadius: '20px',
        background: '#f6f9fc',
        color: '#525f7f',
        border: '1px solid #dee2e6',
        whiteSpace: 'nowrap'
      }
    },
    escalaBadgeStyle () {
      var s = estiloEscala(this.auditoria.escala)
      return {
        fontSize: '12px',
        fontWeight: '600',
        padding: '4px 12px',
        borderRadius: '20px',
        background: s.background,
        color: s.color,
        whiteSpace: 'nowrap'
      }
    },
    fechaFormateada () {
      if (!this.auditoria.fecha) return ''
      var raw = this.auditoria.fecha
      var d = new Date(raw.indexOf('T') === -1 ? raw + 'T00:00:00' : raw)
      if (isNaN(d.getTime())) return this.auditoria.fecha
      var months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
      return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear()
    }
  }
}
</script>
